import React, { memo } from 'react'

import { HourglassEmpty2, Icon, classnames } from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { node, string } from 'prop-types'

import useTranslation from 'Pods/ThreeDStudio/Hooks/useTranslation'

function Placeholder({ title, description, children, className = '' }) {
  const t = useTranslation()

  return (
    <div className={classnames('enhance-model-panel__tab placeholder', className)}>
      <span className="enhance-model-panel__title cgt-heading-50">{title}</span>
      <div className="placeholder__content">
        <div className="placeholder__text">
          <div className="placeholder__coming-soon">
            <Icon svgComponent={HourglassEmpty2} size="small" color="dark" className="placeholder__coming-soon-icon" />
            <span className="placeholder__coming-soon-label cgt-body-base-semibold">
              {t('shared.placeholder.comingSoon')}
            </span>
          </div>
          <p className="placeholder__description cgt-body-md-semibold">{description}</p>
        </div>
        {children}
      </div>
    </div>
  )
}

Placeholder.propTypes = {
  title: string.isRequired,
  description: string.isRequired,
  children: node.isRequired,
  className: string,
}

export default memo(Placeholder)
